<template>
  <div class="steps">
    <div class='step-wrap'>
      <step-item v-for="(item, index) in stepList" :key='index' :stepData='item' :last="index === stepList.length - 1"></step-item>
    </div>
  </div>
</template>

<script>
import stepItem from '@/views/userRegistration/comp/stepItem';

  export default {
    name:'fillStep',
    data() {
      return {
        active: 2,
        stepList: [
          {
            url:'/baseInfo',
            title:"基本信息",
            current: 0
          },{
            url:'/education',
            title:'学历技能',
            current: 1
          },{
            url:'/workExperience',
            title:'工作经历',
            current: 2
          },{
            url:'/signature',
            title:'确认签字',
            current: 3
          }
        ]
      }
    },
    components:{
      stepItem
    }
    
  }
</script>

<style lang="less" scoped>
.steps {
  background: #f8ba5a;
  border: 0px solid transparent;
  border-radius: 0 0 12px 12px;
  padding: 10px 0 0 20px;
}
.step-wrap{
  display: flex;
  padding-bottom: 30px;
}
</style>
